import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import InterviewGuideQuestion from './InterviewGuideQuestion';

class InterviewGuide extends DomainObject {
  name;
  questions = [];

  _relations = {
    questions: [InterviewGuideQuestion]
  };

  constructor(other) {
    super();

    makeObservable(this, {
      name: observable,
      questions: observable
    });

    this.merge(other);
  }
}

export default InterviewGuide;

